import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid,
  LineChart, Line, ResponsiveContainer, Legend,
  PieChart, Pie, Cell
} from "recharts";

function DashboardAlarmas() {
  const [estadisticas, setEstadisticas] = useState({
    estado_counts: [],
    tendencia_diaria: [],
    tendencia: "",
    ranking_alarmas: [],
  });

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    axios.get(`${API_URL}/api/estadisticas-alarmas/`)
      .then(response => {
        setEstadisticas(response.data);
      })
      .catch(error => console.error("Error al obtener estadísticas:", error));
  }, [API_URL]);

  const estadosData = estadisticas.estado_counts.map(item => ({ name: item.estado, value: item.total }));
  const tendenciaData = estadisticas.tendencia_diaria.map(item => ({ name: item.dia, total: item.total }));

  const COLORS = ["#FF8042", "#0088FE", "#FFBB28", "#00C49F"];

  // 🔺 Ícono según tendencia
  const tendenciaTexto = {
    sube: "🔺 Las alarmas están aumentando hoy.",
    baja: "🟢 Menos alarmas hoy que ayer.",
    igual: "⚖️ Mismo número de alarmas que ayer."
  };

  return (
    <div>
      <h2>📊 Dashboard de Alarmas</h2>
      <div className="contenedor">
        <div className="row mb-4">
          <div className="col-md-12">
            <h5 className="text-primary">{tendenciaTexto[estadisticas.tendencia]}</h5>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <h4>📌 Distribución de Alarmas por Estado</h4>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie data={estadosData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={100} label>
                  {estadosData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="col-md-6">
            <h4>📈 Tendencia de Alarmas en la Última Semana</h4>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={tendenciaData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="total" stroke="#8884d8" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-12">
            <h4>📌 Alarmas Registradas por Día</h4>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={tendenciaData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="total" fill="#82ca9d" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-md-6">
            <h4>🏆 Alarmas Más Repetidas</h4>
            <ul className="list-group">
              {estadisticas.ranking_alarmas.map((item, index) => (
                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                  {item.alarma__descripcion} 
                  <span className="badge bg-primary rounded-pill">: {item.total}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

      </div>
    </div>
  );
}

export default DashboardAlarmas;
